import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core"

@Component({
    templateUrl: "privacidad-proteccion-datos.component.html"
})
export class PrivacidadProteccionDatosComponent {}
